import {
  INVESTORS_FETCH_REQUESTED,
  INVESTORS_FETCHED,
  INVESTORS_FETCH_FAILED,
  INVESTOR_FETCH_REQUESTED,
  INVESTOR_FETCHED,
  INVESTOR_FETCH_FAILED,
  TOGGLE_SPINNER,
  TOGGLE_NOTIFICATION,
} from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';

const dispatchInvestor = (dispatch) => (data) => {
  return dispatch({
    type: INVESTOR_FETCHED,
    data: { investor: data.investor || data }
  });
}

export const createInvestor = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.createInvestor(attrs)
    .then(dispatchInvestor(dispatch));
};

export const updateInvestor = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.updateInvestor(attrs)
    .then(dispatchInvestor(dispatch));
};

export const fetchInvestor = (id) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: INVESTOR_FETCH_REQUESTED,
    action: api.fetchInvestor(id),
    success: INVESTOR_FETCHED,
    failure: INVESTOR_FETCH_FAILED
  });
};

export const fetchInvestors = () => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: INVESTORS_FETCH_REQUESTED,
    action: api.fetchInvestors(),
    success: INVESTORS_FETCHED,
    failure: INVESTORS_FETCH_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/investors.js